<template>
  <div id="footerjp">
    <div class="footer-main">
      <div class="footer-main-block footer-container">
        <div class="footer-logo hidden-xs hidden-sm">
          <img src="@/assets/img/footer_logo.png" @click="GoTop()" />
        </div>
        <div class="text-nav hidden-xs hidden-sm">
          <div class="text">
            <router-link to="/jp/trend"><span>base</span>ニュース</router-link>
          </div>
          <div class="text">
            <router-link to="/jp/jobchance">採用情報</router-link>
          </div>
          <div class="text">
            <router-link to="/jp/apartment">アパートメントについて</router-link>
          </div>
          <div class="text">
            <router-link to="/jp/aboutus"><span>base</span>について</router-link>
          </div>
          <div class="text">
            <router-link to="/jp/esg"><span>ESG</span>対策と実践</router-link>
          </div>
          <div class="text">
            <router-link to="/jp/checkin">安全対策サービス</router-link>
          </div>
        </div>
        <div class="icon hidden-xs hidden-sm">
          <div class="icon-left">
            <div class="icon-text">公式サービスダイヤル</div>
            <div class="icon-tel"><a href="tel:400-700-6008">400-700-6008</a></div>
            <div class="icon-block">
              <div class="icon-img">
                <a href="mailto:enquiry.base@base-china.com"><img src="@/assets/img/footer_icon_2_black.png" /></a>
              </div>
              <div class="icon-img" @click="openWePop(require('@/assets/img/footer_wecode_2.jpg'), 1)">
                <img src="@/assets/img/footer_icon_3_black.png" />
              </div>
              <div class="icon-img" @click="openWePop(require('@/assets/img/footer_wecode_1.jpg'), 2)">
                <img src="@/assets/img/footer_icon_4_black.png" />
              </div>
              <div class="icon-img" @click="openWePop(require('@/assets/img/footer_wecode_3.jpg'), 3)">
                <img src="@/assets/img/footer_icon_6_black.png" />
              </div>
            </div>
          </div>
          <div class="icon-b-img">
            <img src="@/assets/img/footer_icon_wechat.png" />
            <div class="icon-b-text">ウィチャットミニープログラム<br />（<span>base</span>佰舎公式アカウント）</div>
          </div>
        </div>
        <!-- mobile======== -->
        <div class="icon visible-xs visible-sm">
          <div class="icon-b-img">
            <img src="@/assets/img/footer_icon_wechat.png" />
            <div class="icon-b-text">開ける，より多くの情報を得る</div>
          </div>
          <div class="icon-left">
            <!-- <div class="icon-text">官方热线</div> -->
            <div class="icon-tel"><a href="tel:400-700-6008">400-700-6008</a></div>
            <div class="icon-block">
              <div class="icon-img">
                <a href="mailto:enquiry.base@base-china.com"><img src="@/assets/img/footer_icon_2_black.png" /></a>
              </div>
              <div class="icon-img" @click="openWePop(require('@/assets/img/footer_wecode_2.jpg'), 1)">
                <img src="@/assets/img/footer_icon_3_black.png" />
              </div>
              <div class="icon-img">
                <a href="https://v.douyin.com/B8TwFC7/"><img src="@/assets/img/footer_icon_4_black.png" /></a>
              </div>
              <div class="icon-img">
                <a
                  href="https://www.xiaohongshu.com/user/profile/5df89dbd0000000001004d64?xhsshare=CopyLink&appuid=5c77a8aa0000000016010249&apptime=1675063783"><img
                    src="@/assets/img/footer_icon_6_black.png" /></a>
              </div>
              <!-- <div class="icon-img" @click="openWePop(require('@/assets/img/footer_wecode_1.jpg'), 2)">
                <img src="@/assets/img/footer_icon_4_black.png" />
              </div> -->
              <!-- <div class="icon-img" @click="openWePop(require('@/assets/img/footer_wecode_3.jpg'), 3)">
                <img src="@/assets/img/footer_icon_6_black.png" />
              </div> -->
            </div>
          </div>
        </div>
        <div class="text-nav visible-xs visible-sm">
          <div class="text-nav-ct">
            <div class="footer-logo">
              <img src="@/assets/img/footer_logo.png" @click="GoTop()" />
            </div>
            <div class="text-nav-block">
              <div class="text">
                <router-link to="/jp/trend"><span>base</span>ニュース</router-link>
              </div>
              <div class="text">
                <router-link to="/jp/jobchance">採用情報</router-link>
              </div>
              <div class="text">
                <router-link to="/jp/apartment">アパートメントについて</router-link>
              </div>
              <div class="text">
                <router-link to="/jp/aboutus"><span>base</span>について</router-link>
              </div>
              <div class="text">
                <router-link to="/jp/esg"><span>ESG</span>対策と実践</router-link>
              </div>
              <div class="text">
                <router-link to="/jp/checkin">安全対策サービス</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- mobile======== end -->
      </div>
    </div>
    <div class="footer-jt">
      <div class="footer-jt-block footer-container">
        <div class="footer-jt-pic">
          <img src="@/assets/img/footer_jt_pic.png" />
        </div>
      </div>
      <div class="footer-icp footer-l-item"><a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备15052590号-1</a>
      </div>
    </div>
    <!-- <div class="footer-links">
      <div class="footer-links-block footer-container">
        <div class="footer-copyright footer-l-item">
          <img src="@/assets/img/footer_policy_icon.png" />
          <div class="copy">沪公网安备 310XXXXXXXXXXX号</div>
        </div>
        <div class="footer-icp footer-l-item">沪ICP备15052590号-1</div>
      </div>
    </div> -->
    <div v-show="isWecodePopShow" id="wecode-pop">
      <div class="bg">
        <div class="close-pop" @click="closeWeCodePop"><img src="@/assets/img/icon_close.png" /></div>
        <div class="bg-block">
          <img :src="tempwecodeurl" class="wecodeimg" />
          <div class="wecodeinfo" v-html="tempewcodeinfo"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footerjp",
  data() {
    return {
      isWecodePopShow: false,
      tempwecodeurl: '',
      tempewcodeinfo: ''
    };
  },
  methods: {
    openWePop(url, type) {
      switch (type) {
        case 1:
          this.tempewcodeinfo = '【WeChat】<br />（<span>base</span>佰舎公式アカウント）'
          break;
        case 2:
          this.tempewcodeinfo = '【抖音】<br />（<span>base</span>佰舎公式アカウント）'
          break;
        case 3:
          this.tempewcodeinfo = '【小紅书】<br />（<span>base</span>佰舎公式アカウント）'
          break;
      }
      this.tempwecodeurl = url;
      this.isWecodePopShow = true;
    },

    closeWeCodePop() {
      this.isWecodePopShow = false;
      this.tempwecodeurl = '';
      this.tempewcodeinfo = '';
    },

    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    }
  },
};
</script>
<style lang="scss" scoped>
a {
  &:focus {
    text-decoration: none;
  }

  &:hover {
    text-decoration: none;
  }
}

#footerjp {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  font-family: $KM;

  .footer-container {
    width: 1200px;
    margin: 0 auto;
  }

  .footer-main {
    background: #fff;
    border-top: 1px solid #d8d8d8;
    //background: rgba(5, 24, 38, 0.9);

    .footer-main-block {
      padding: 30px 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .footer-logo {
        width: 100px;
        height: 48.8px;
        margin-left: 16px;
        margin-right: 38px;
        cursor: pointer;

        img {
          width: 100%
        }
      }

      .text-nav {
        width: 650px;
        height: 50px;
        margin-right: 20px;
        padding-left: 54px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .text {
          width: 190px;
          margin-right: 12px;
          font-size: 14px;
          letter-spacing: 0.1em;

          span {
            font-family: $FM6;
          }

          a {
            color: #272727;

            &:hover {
              color: #3C5896;
            }
          }

          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }

      .icon {
        display: flex;
        align-items: center;

        .icon-left {
          margin-right: 20px;

          .icon-text {
            font-size: 14px;
            font-weight: normal;
            line-height: 17px;
            color: #3D3D3D;
            text-align: right;
          }

          .icon-tel {
            font-family: $FH4;
            font-size: 23px;
            font-weight: normal;
            color: #3D3D3D;

            a {
              color: #3D3D3D;
            }
          }

          .icon-block {
            display: flex;
            align-items: center;

            .icon-img {
              margin-right: 10px;
              cursor: pointer;

              &:last-child {
                margin-right: 0;
              }

              img {
                max-width: 30px;
              }
            }
          }

        }

        .icon-b-img {
          margin-right: 4px;

          img {
            width: 100px;
            height: 100px;
            margin: 0 auto;
          }

          .icon-b-text {
            text-align: center;
            font-size: 14px;
            color: #272727;
            span{
              font-family: $FM6;
            }
          }
        }
      }
    }
  }

  .footer-jt {
    background: rgba(5, 24, 38, 0.98);
    display: flex;
    align-items: center;

    .footer-jt-block {
      flex: 1;
      padding: 17px 0;
      display: flex;
      align-items: center;
      justify-content: center;

      .footer-jt-pic {
        width: 180px;

        img {
          width: 100%;
        }
      }
    }

    .footer-icp {
      font-size: 12px;
      font-weight: normal;
      color: #8D8D8D;
      padding-right: 32px;

      a {
        color: #8D8D8D;
      }
    }
  }

  .footer-links {
    background: #051826;

    .footer-links-block {
      padding: 25px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #8D8D8D;
      font-size: 14px;

      .footer-l-item {
        padding-left: 12px;
        padding-right: 12px;

        &:last-child {
          border-right: none;
        }
      }

      .footer-copyright {
        display: flex;
        align-items: center;

        .copy {
          margin-left: 8px;
        }

        img {
          max-width: 26px;
        }
      }
    }

  }

  #wecode-pop {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1005;
    background: rgba(0, 0, 0, 0.8);


    .bg {
      width: 400px;
      height: 450px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      .close-pop {
        width: 25px;
        height: 25px;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        z-index: 100;

        img {
          width: 100%;
        }
      }

      .bg-block {
        width: 400px;
        height: 420px;
        border-radius: 15px;
        box-sizing: border-box;
        background: #fff;
        position: absolute;
        bottom: 0;
        left: 0;

        .wecodeimg {
          width: 250px;
          height: 250px;
          margin: 60px auto 10px;
        }

        .name {
          font-family: SourceHanSansCN-Bold;
          font-size: 16px;
          font-weight: bold;
          color: #3D3D3D;
          text-align: center;
        }

        .wecodeinfo {
          text-align: center;
          font-size: 14px;
          font-weight: normal;
          color: #3D3D3D;
          font-family: $FM6;
        }
      }
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 996px) {
  #footerjp {
    .footer-container {
      width: 96%;
      margin: 0 auto;
    }

    .footer-main {

      .footer-main-block {
        padding: 40px 0;
        display: block;

        .footer-logo {
          width: 80px;
          height: auto;
          margin-left: 26px;
          margin-right: 0;
          border-right: 1px solid #000;

          img {
            width: 50px;
          }
        }

        .text-nav {
          width: 100%;
          height: auto;
          margin: 20px auto 0;
          padding-left: 0;

          .text-nav-ct {
            width: 96%;
            margin: 0 auto;
            display: flex;
            align-items: center;
            overflow: hidden;
            justify-content: center;

            .text-nav-block {
              display: flex;
              align-items: center;
              flex-wrap: wrap;

              .text {
                width: 33%;
                margin-left: 0;
                margin-right: 0;
                margin-bottom: 5px;
                text-align: center;
                font-size: 12px;
                line-height: 14px;
                letter-spacing: 0;
              }
            }
          }

        }

        .icon {
          width: 80%;
          margin: 0 auto;
          display: block;

          .icon-left {
            width: 100%;
            margin: 0 auto 0;

            .icon-text {
              text-align: center;
              font-size: 12px;
            }

            .icon-tel {
              text-align: center;
            }

            .icon-block {
              justify-content: center;

              .icon-img {
                margin-right: 20px;

                img {
                  max-width: 40px;
                }
              }
            }
          }

          .icon-b-img {
            margin: 0 auto 20px;

            img {
              width: 140px;
              height: 140px;
              margin-bottom: 10px;
            }

            .icon-b-text {
              font-size: 12px;

              span {
                font-family: $KM;
              }
            }
          }
        }

        .icon-big {
          width: 80%;
          margin: 20px auto 0;

          .icon-big-top {
            justify-content: center;
          }
        }
      }
    }
  }
}


@media screen and (min-width: 997px) and (max-width: 1199px) {
  #footerjp {

    .footer-container {
      width: 970px;
      margin: 0 auto;
      justify-content: space-between;
    }

    .footer-main {

      .footer-main-block {

        .footer-logo {
          margin-right: 34px;
        }

        .text-nav {
          width: 490px;
          margin-right: 0;

          .text {
            margin-right: 0;
            margin-left: 0;
          }
        }

        .icon {
          margin-right: 10px;

          .icon-left {


            .icon-text {}

            .icon-tel {}

            .icon-block {


              .icon-img {}
            }
          }

          .icon-b-img {}
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {}

@media only screen and (max-width: 768px) {
  #footerjp {
    .footer-container {
      width: 96%;
      margin: 0 auto;
    }

    .footer-main {

      .footer-main-block {
        padding: 40px 0;
        display: block;

        .footer-logo {
          width: 50px;
          height: auto;
          margin-left: auto;
          margin-right: auto;
          margin-bottom: 20px;

          img {
            width: 50px;
          }
        }

        .text-nav {
          width: 100%;
          height: auto;
          margin: 20px auto 0;
          padding-left: 0;

          .text-nav-ct {
            width: 100%;
            margin: 0 auto;
            display: block;

            .text-nav-block {
              display: flex;
              align-items: center;
              flex-wrap: wrap;

              .text {
                width: 20%;
                margin-left: 0;
                margin-right: 0;
                margin-bottom: 5px;
                text-align: center;
                font-size: 12px;
                line-height: 14px;
                letter-spacing: 0;

                &:nth-child(2) {
                  width: 50%;
                }

                &:nth-child(3) {
                  width: 30%;
                }

                &:nth-child(5) {
                  width: 50%;
                }

                &:nth-child(6) {
                  width: 30%;
                }
              }
            }
          }

        }

        .icon {
          width: 80%;
          margin: 0 auto;
          display: block;

          .icon-left {
            width: 100%;
            margin: 0 auto 0;

            .icon-text {
              text-align: center;
              font-size: 12px;
            }

            .icon-tel {
              text-align: center;
            }

            .icon-block {
              justify-content: center;

              .icon-img {
                margin-right: 20px;

                img {
                  max-width: 40px;
                }
              }
            }
          }

          .icon-b-img {
            margin: 0 auto 20px;

            img {
              width: 140px;
              height: 140px;
              margin-bottom: 10px;
            }

            .icon-b-text {
              font-size: 12px;

              span {
                font-family: $KM;
              }
            }
          }
        }

        .icon-big {
          width: 80%;
          margin: 20px auto 0;

          .icon-big-top {
            justify-content: center;
          }
        }
      }
    }

    .footer-jt {
      display: block;

      .footer-jt-block {
        .footer-jt-pic {}
      }

      .footer-icp {
        text-align: center;
        padding-right: 0;
        padding-bottom: 17px;
      }
    }

    .footer-links {
      .footer-links-block {
        display: block;

        .footer-l-item {
          padding-left: 12px;
          padding-right: 12px;

          &.footer-icp {
            text-align: center;
          }

          &:last-child {
            border-right: none;
          }
        }

        .footer-copyright {
          display: flex;
          align-items: center;
          justify-content: center;

          .copy {
            margin-left: 8px;
          }

          img {
            max-width: 26px;
          }
        }
      }

    }

    #wecode-pop {
      .bg {
        width: 90%;

        .close-pop {}

        .bg-block {
          width: 100%;

          .wecodeimg {}


        }
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/Footerjp.vue